window.onload = function() {
	document.getElementById('preloader').classList.add("is-hidden");
	document.getElementById('app').classList.remove("is-hidden");
};